<template>
  <div class="w-full text-error flex">
    <div class="pt-2 px-2 icon">
      <slot name="icon">
        <XMarkIcon />
      </slot>
    </div>
    <div class="pt-2 pl-0 text-14 text">
      <slot name="text"></slot>
    </div>
  </div>
</template>

<script>
import { XMarkIcon } from '@/components/icons/fontIcons';

export default {
  name: 'ValidationError',
  components: {
    XMarkIcon,
  },
};
</script>
